import script from "./AdminFormElementFile.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementFile.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementFile.vue?vue&type=style&index=0&id=6b8b7ca6&lang=scss"

const __exports__ = script;

export default __exports__